import React from 'react';
import { TextField } from '../../../components/inputs';
import { FormikSingleSelect as SingleSelectField } from '../../../components/inputs/SingleSelectField';
import CheckBox from '../../../components/inputs/CheckBox';
import AppTooltip from '../../../../components/shared/AppTooltip';
import { noop } from '../../../../helperFunctions';

const ParentGuardianInformation = ({
  values = {},
  filters = {},
  emailRequired,
  phoneRequired,
  guardianContactRequired,
  orgName,
  setFieldValue = noop,
  styles = {},
}) => {
  const fields = filters?.fields;
  const data = filters?.data;

  if (!fields || !data) return null;

  const options = fields?.relationship_type?.options || [];
  const selection = options.find((o) => o.value === values.relationship_type);
  const isSelf = selection?.title === 'self';
  const isOther = selection?.title === 'other';

  return (
    <section className={`legal-guardian-info ${styles.section}`}>
      <div className="flex">
        <h4 className={styles.sectionTitles}>
          {fields?.guardian_header?.label}
        </h4>
      </div>
      <div className={`flex flex-col ${styles.fieldsetWrapper}`}>
        <div className={styles.fieldsWrapper}>
          <SingleSelectField
            placeholder={fields?.relationship_type?.placeholder}
            name="relationship_type"
            options={options}
            valueKey="value"
            labelKey="label"
            customClass="field-react-wrapper"
            showError
            lucetTheme
            onChange={(opt) => {
              const isSelectedSelf =
                options.find((o) => o.value === opt?.value)?.title === 'self';
              if (isSelectedSelf && !guardianContactRequired) {
                setFieldValue('use_parent_guardian_info', false);
              }
            }}
          />
        </div>

        {!isSelf && (
          <React.Fragment>
            {isOther && (
              <div className={styles.fieldsWrapper}>
                <TextField
                  name="relationship_type_other"
                  type="text"
                  placeholder={fields?.relationship_type_other?.placeholder}
                />
              </div>
            )}

            {fields.parent_guardian_first_name?.visible && (
              <div className={styles.fieldsWrapper}>
                <TextField
                  name="parent_guardian_first_name"
                  type="text"
                  placeholder={fields?.parent_guardian_first_name?.placeholder}
                />
              </div>
            )}

            {fields.parent_guardian_last_name?.visible && (
              <div className={styles.fieldsWrapper}>
                <TextField
                  name="parent_guardian_last_name"
                  type="text"
                  placeholder={fields?.parent_guardian_last_name?.placeholder}
                />
              </div>
            )}

            <div className={styles.fieldsWrapper}>
              {phoneRequired &&
                emailRequired &&
                fields?.parent_guardian_phone_number?.visible && (
                  <div className={`${styles.validationWarningMessage}`}>
                    <span>{fields?.email_phone_warning?.label}</span>
                  </div>
                )}

              {fields.parent_guardian_email?.visible && (
                <div className={styles.comboField}>
                  {fields.parent_guardian_confirm_email?.visible && (
                    <div className={styles.checkboxWrapper}>
                      <CheckBox
                        name="parent_guardian_confirm_email"
                        checked={values.parent_guardian_confirm_email}
                        disabled={emailRequired}
                      />
                    </div>
                  )}
                  <TextField
                    name="parent_guardian_email"
                    type="text"
                    placeholder={fields?.parent_guardian_email?.placeholder}
                    mask="email"
                    className={
                      values.parent_guardian_confirm_email ? '' : 'greyed-out'
                    }
                    customClass="flex-1"
                  />
                </div>
              )}
            </div>

            {fields.parent_guardian_phone_number?.visible && (
              <div className={styles.fieldsWrapper}>
                <div className={styles.comboField}>
                  {fields.parent_guardian_confirm_phone_number?.visible && (
                    <div className={styles.checkboxWrapper}>
                      <CheckBox
                        name="parent_guardian_confirm_phone_number"
                        checked={values.parent_guardian_confirm_phone_number}
                        disabled={phoneRequired}
                      />
                    </div>
                  )}
                  <TextField
                    name="parent_guardian_phone_number"
                    type="text"
                    placeholder={
                      fields?.parent_guardian_phone_number?.placeholder
                    }
                    mask="phone"
                    className={
                      values.parent_guardian_confirm_phone_number
                        ? ''
                        : 'greyed-out'
                    }
                    customClass="flex-1"
                  />
                </div>
              </div>
            )}

            {fields.use_parent_guardian_info?.visible && (
              <div
                className={`${styles.fieldsWrapper} ${styles.checkboxWrapper} padding-top-sm padding-bottom-sm`}
                data-tip={guardianContactRequired ? true : undefined}
                data-for={
                  guardianContactRequired
                    ? 'guardian-contact-required-tooltip'
                    : undefined
                }
              >
                <CheckBox
                  label={fields?.use_parent_guardian_info?.label}
                  name="use_parent_guardian_info"
                  checked={guardianContactRequired || values.use_parent_guardian_info}
                  disabled={guardianContactRequired}
                  labelClass="mss_cc_info_label"
                />
                {guardianContactRequired && (
                  <AppTooltip
                    id="guardian-contact-required-tooltip"
                    place="bottom"
                    arrowColor="#222"
                    multiline
                  >
                    {`${orgName || 'This provider'} requires parent/guardian email & phone.`}
                  </AppTooltip>
                )}
              </div>
            )}
          </React.Fragment>
        )}
      </div>
    </section>
  );
};

export default ParentGuardianInformation;
